<template>
  <div class="wizard-body small-12 medium-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.DESC')"
    />
    <div class="medium-8 columns">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.PROVIDERS.LABEL') }}
        <select v-model="provider" disabled="true">
          <option value="whatsapp_personal">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP_PERSONAL.PROVIDERS.WA_PERSONAL') }}
          </option>
        </select>
      </label>
    </div>

    <WApersonalProvider />
    <!-- <twilio
      v-if="provider === 'twilio'"
      type="whatsapp"
      :whatsapp-inbox="false"
      :communal-inboxes-details="communalInboxes"
    ></twilio>
    <three-sixty-dialog-whatsapp
      v-else
      :whatsapp-inbox="false"
      :communal-inboxes-details="communalInboxes"
    /> -->
  </div>
</template>

<script>
import PageHeader from '../../SettingsSubPageHeader';
// import Twilio from './Twilio';
import WApersonalProvider from './WApersonalProvider.vue';
import { mapGetters } from 'vuex';
import channelFactory from "../../../settings/inbox/channel-factory";

export default {
  components: {
    PageHeader,
    // Twilio,
    WApersonalProvider,
  },
  computed: {
    ...mapGetters({
    //   communalInboxes: 'accounts/getCommunalInboxes',
    currentUser: 'getCurrentUser',
    inboxes: 'inboxes/getInboxes',
    getAccount: 'accounts/getAccount',
    }),
    currentAccount(){
      return this.getAccount(this.currentUser.account_id);
    },
  },

  mounted() {
    // this.provider = this.communalInboxes.provider;
  },
  data() {
    return {
      provider: 'whatsapp_personal',
    };
  },
  watch: {
    inboxes: {
      handler (newValue, oldValue){
        this.redirectForDisabledChannel();
      },
      deep: true,
      immediate: true,
    },
  },
  methods:{
    redirectForDisabledChannel(){

      const channelKey  = 'whatsapp personal';
      const isDisableWhatsappInboxCreate = channelFactory.disableInboxCreate(channelKey,this.currentUser,this.inboxes,{currentAccount:this.currentAccount  });
      if (isDisableWhatsappInboxCreate) {
        console.log('Redirecting...');
        this.$router.push(`/app/accounts/${this.currentUser.account_id}/settings/inboxes/new`);
      }

    },
  },
};
</script>
